import angular from 'angular';
import template from './talentExpertHiringFunnelView.html';

export class TalentExpertHiringFunnelComponent {
    /* @ngInject */
    constructor() {
        const talentExpertHiringFunnelCtrl = this;
        talentExpertHiringFunnelCtrl.init = function () {

        };

        talentExpertHiringFunnelCtrl.init();
    }
}

export const TalentExpertHiringFunnelComponentConfiguration = {
    template,
    controller: TalentExpertHiringFunnelComponent,
    controllerAs: 'talentExpertHiringFunnelCtrl',
};

angular
    .module('TALENYA-FE')
    .component('talentExpertHiringFunnelComponent', TalentExpertHiringFunnelComponentConfiguration);
